import { redoDesignerChange, undoDesignerChange } from "../../designer-history-actions";
import { getSdInstance } from "../helpers";
import type { ToolHandlerGroup } from "../types";

export const historyTools: ToolHandlerGroup = {
  sync: {
    ui_common_undo: () => undoDesignerChange(getSdInstance()),
    ui_common_redo: () => redoDesignerChange(getSdInstance())
  }
};
